import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { Cost } from "../../../domain/contracts/Cost";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read Cost info for a given DOT_PayItem{index} aspect.
 */
function buildCostByElementQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.Cost.EstimateType  AS EstimateType,
      p.Cost.EngEstPrice   AS EngEstPrice,
      p.Cost.Override      AS Override,
      p.Cost.Factor        AS Factor,
      p.Cost.UnitPrice     AS UnitPrice,
      p.Cost.ItemCost      AS ItemCost
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryCostForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<Cost | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildCostByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any;  // { EstimateType, EngEstPrice, Override, Factor, UnitPrice, ItemCost }
    return Cost.fromObject(plain);
  }

  // No Cost info for that element/index
  return undefined;
}
